var config = require('../../config').config;
var mailMemberArray = [];
var batch = 15; //the number of Avatars shown at a time in modal
var selectedAvatars = 0;
var modal;
var submitBtn;

function init(){
  //look for array data
  var arrayData = document.querySelector('[data-mail-array]');
  if(arrayData){
    mailMemberArray = JSON.parse(arrayData.dataset.mailArray);
    renderChoiceAvatars();
  }
}

function getArrayLength(){
  return mailMemberArray.length;
}

function renderChoiceAvatars(){
  if (mailMemberArray.length > 0) {
    //find modal
    modal = document.getElementById('modal');
    if (modal) {
      //find submit button
      submitBtn = modal.querySelector('[name=submit]')
    }
    
    // find div to append choice avatars into
    var holder = document.querySelector('[data-choiceAvatar-holder]')
    //make sure the holder is empty
    holder.innerHTML = '';
    // find the choice avatar template
    var tmp = document.getElementById('choiceAvatar').content;

    if(holder && tmp) {
      //loop over array
      for (var i = 0; i < mailMemberArray.length; i++) {
        if (i < batch) {
          var clonedTmp = tmp.cloneNode(true)
          var label = clonedTmp.querySelector('label');

          if (label) {
            //set label
            label.setAttribute('for', mailMemberArray[i].id+'-c');
            //set input values
            var inputData = clonedTmp.querySelector('input');
            inputData.setAttribute('id', mailMemberArray[i].id+'-c');
            inputData.setAttribute('value', mailMemberArray[i].id);
            inputData.addEventListener('click', checkAvatarSelection)
            //set name
            var nameHolder = label.querySelector('[data-name]')
            if(nameHolder){
              nameHolder.innerHTML = decodeURIComponent(mailMemberArray[i].name);
            }
            //set age and city
            var detailsHolder = label.querySelector('[data-details]')
            if(detailsHolder){
              //if massMailShowCountry is true, Age and Country is shown below image
              var detailsCountryCity = (config.massMailShowCountry)? decodeURI(mailMemberArray[i].country) : decodeURI(mailMemberArray[i].city);
              var detailsContent = mailMemberArray[i].age +" <span>&#8226;</span> "+detailsCountryCity;
              detailsHolder.innerHTML = detailsContent;
              //set title on label
              label.setAttribute('title', mailMemberArray[i].age+', '+decodeURI(mailMemberArray[i].city)+', '+decodeURI(mailMemberArray[i].country));
            }
            //set image
            var image = label.querySelector('[style]');
            var imagePath = image.getAttribute('style');
            //member has a photo
            if(parseInt(mailMemberArray[i].photo) > 0){
              // https://cdn.ukrainedate.com/memphoto/Photo1/small/{ID}.jpg
              var newImagePath = imagePath.replace('{ID}', mailMemberArray[i].id);
              image.setAttribute('style', newImagePath);
            } else {
              //member has no photo, so set their gender
              var svg = '<div class="svg circle fit mb1-5 bg-light-grey"><svg class="icon-120 flex-none svg-fit avoid-clicks"><use xlink:href="/assets/desktop/icons/icons.svg#no-image-avatar-'+mailMemberArray[i].gender+'"></use></svg></div>'
              image.remove()
              label.insertBefore(document.createRange().createContextualFragment(svg), label.children[1])
            }


            holder.appendChild(clonedTmp)

            selectedAvatars = i+1; // add 1 as it's a array count which is 0 based
          }
        }
      }
      //now remove the first 15 'Batch' from array
      mailMemberArray.splice(0, batch)
    }
  }
}

function checkAvatarSelection(e){
  var item = e.currentTarget
  if (item.checked == false) {
    selectedAvatars = selectedAvatars - 1
  } else {
    selectedAvatars = selectedAvatars + 1
  }
  
  if(selectedAvatars == 0){
    // if nothing left in array, disable send button
    if(mailMemberArray.length == 0){
      if(modal){
        if(submitBtn){
          submitBtn.setAttribute('disabled', true)
        }
      }
    } else {
      renderChoiceAvatars()
    }
  } else {
    // if selectedAvatars is greater than 0, enable send button
    if(modal){
      if(submitBtn){
        submitBtn.removeAttribute('disabled')
      }
    }
  }
}


function renderSentMessage() {
  //disable the send button
  submitBtn.setAttribute('disabled', true)
  // find div to append choice avatars into
  var holder = document.querySelector('[data-choiceAvatar-holder]')
  //find the blurb
  var blurb = document.querySelector('[data-content-blurb]')
  //find response markup
  var responce = document.getElementById('mailSent')
  if (responce) {
    if (blurb) {
      //hide blurb
      blurb.classList.toggle('hide')
    }
    var message = responce.cloneNode(true)
    message.classList.remove('hide')
    message.classList.add('scale-in-center')
    //show 'message sent'
    holder.appendChild(message)
    // 2 second delay before clearing 'message sent'
    setTimeout(function(){
      renderChoiceAvatars()
      if (blurb) {
        //un-hide blurb
        blurb.classList.toggle('hide')
      }
      //enable send button
      submitBtn.removeAttribute('disabled')
    },2000);
  }
}

document.addEventListener('DOMContentLoaded', init);
document.addEventListener('cm-modal-loaded', init);

module.exports.renderSentMessage = renderSentMessage;
module.exports.getArrayLength = getArrayLength;
